import { Component } from '@angular/core';
import { ClientsModule } from '../../../../clients/clients.module';
import { LayoutModule } from '../../../layout/layout.module';

@Component({
  selector: 'app-clients-dashboard-page',
  standalone: true,
  imports: [
    LayoutModule,
    ClientsModule,
  ],
  templateUrl: './clients-dashboard-page.component.html',
  styleUrl: './clients-dashboard-page.component.sass',
})
export class ClientsDashboardPageComponent {

}
